export default __webpack_public_path__ + "static/media/Solped.45880a94.svg";